module.exports = __webpack_public_path__ + "static/assets/81ac0f7621dc24fcad6164749fc2348c.svg";